import { Component, ViewChild, OnInit, AfterViewInit, HostBinding, ElementRef } from '@angular/core';
import { IonSlides, IonContent, AlertController, Platform } from '@ionic/angular';
import { DbService } from '../services/db.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TermsDialogComponent } from '../terms-dialog/terms-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit, AfterViewInit {
  @ViewChild('slides', { static: false }) slides: IonSlides;
  @ViewChild('Content', { static: true }) content: IonContent;

  @HostBinding('style.backgroundImage')
  companyInfor;
  requestSection;
  reqCont;
  request;
  requestTextArea;
  map;
  slides$;
  section$;
  serviceCheck = false;
  form: FormGroup;
  requestList;
  master;
  pager;
  isMobile;
  slideOptsOne = {
    isBeginningSlide: true,
    isEndSlide: false,
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: true,
    speed: 200,
  };
  name;
  submitContent;
  num1: string;
  num2: string;
  num3: string;
  constructor(
    private alertCtrl: AlertController,
    public platform: Platform,
    private fb: FormBuilder,
    private elementRef: ElementRef,
    private db: DbService,
    public dialog: MatDialog
  ) {
    console.log('constructor');
    this.companyInfor = this.db.collection$('companyInfo');
    this.companyInfor.subscribe(data => {
      console.log('data[0].slides', data[0].slides);
      if (data[0].slides.length == 1) {
        console.log('pager false');
        this.pager = false;
      } else {
        console.log('pager true');
        this.pager = true;
      }
    });
    this.db.collection$('master').subscribe(data => {
      console.log('MasterAutoPlay', data);
      this.master = data[0];
      console.log('this.master[0]', this.master);
      this.slideOptsOne.autoplay = this.master.autoSlides;
    });

    if (platform.is('mobileweb') || platform.is('mobile')) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
    console.log('this.isMobile', this.isMobile);

    this.requestSection = this.requestSection = this.db.collection$('requestSection', ref => ref.where('buttonSwitch', '==', true));
    this.slides$ = this.db.collection$('slides');
    this.section$ = this.db.collection$('section', ref => ref.orderBy('order', 'asc').where('switch', '==', true));
    this.request = this.db.collection$('request', ref => ref.orderBy('order', 'asc').where('switch', '==', true));
    this.map = this.db.doc$('map/map01');
    this.request.subscribe(datas => {
      this.requestList = datas;
      console.log(' this.requestList', this.requestList);
      this.form = this.createGroup();
    });

    this.reqCont = this.db.collection$('requestTitle');

    // let group={}
    // form_template.forEach(input_template=>{
    //   group[input_template.label]=new FormControl('');
    // })
    // this.myFormGroup = new FromGroup(group);
    // this.slides.slidePrev();
  }

  slidesPrev(slides: IonSlides, slideOptsOne) {
    slides.slidePrev();
    console.log('slsisl', slideOptsOne);
    if (slideOptsOne.autoplay) {
      slides.startAutoplay();
    } else {
      slides.stopAutoplay();
    }
  }

  slideNext(slides: IonSlides, slideOptsOne) {
    slides.slideNext();
    console.log('slsisl', slideOptsOne);
    if (slideOptsOne.autoplay) {
      slides.startAutoplay();
    } else {
      slides.stopAutoplay();
    }
  }
  submit() {
    let form = {
      id: `form_${new Date().getTime()}`,
      dateCreated: new Date().toISOString(),
      sec3: this.submitContent,
      sec1: this.name,
      sec2: `${this.num1}-${this.num2}-${this.num3}`,
      check: false,
    };
    console.log(form);
    this.db.updateAt(`userRequest/${form.id}`, form).then(() => {
      this.name = '';
      this.submitContent = '';
      this.serviceCheck = false;
      this.num1 = '';
      this.num2 = '';
      this.num3 = '';
      this.presentAlert('문의 완료', '문의가 완료되었습니다. 담당자가 확인후 연락드리겠습니다.');
    });
  }


  opersonal() {
    this.dialog.open(TermsDialogComponent, {
      panelClass: 'meeting-popup',
    });
  }

  // // Move to Next slide
  // slideNext(object, slideView) {
  //   slideView.slideNext(500).then(() => {
  //     this.checkIfNavDisabled(object, slideView);
  //   });
  // }

  // // Move to previous slide
  // slidePrev(object, slideView) {
  //   slideView.slidePrev(500).then(() => {
  //     this.checkIfNavDisabled(object, slideView);
  //   });;
  // }

  // // Method called when slide is changed by drag or navigation
  // SlideDidChange(object, slideView) {
  //   this.checkIfNavDisabled(object, slideView);
  //   console.log('SlideDidChange1', object);
  //   console.log('SlideDidChange2', slideView);
  // }

  // // Call methods to check if slide is first or last to enable disbale navigation
  // checkIfNavDisabled(object, slideView) {
  //   this.checkisBeginning(object, slideView);
  //   this.checkisEnd(object, slideView);
  // }

  // checkisBeginning(object, slideView) {
  //   slideView.isBeginning().then((istrue) => {
  //     object.isBeginningSlide = istrue;
  //   });
  // }
  // checkisEnd(object, slideView) {
  //   slideView.isEnd().then((istrue) => {
  //     object.isEndSlide = istrue;
  //   });
  // }

  ngOnInit() {
    console.log('ngOnInit');
    this.db.collection$('companyInfo').subscribe((data: any) => {
      this.elementRef.nativeElement.style.setProperty('--my-var', data[0].color);
    });
  }

  createGroup() {
    const group = {};
    this.requestList.forEach(data => {
      group[data.order] = data.required ? new FormControl('', Validators.required) : new FormControl('');
    });
    console.log('group', group);

    return new FormGroup(group);
  }
  ngAfterViewInit() {
    console.log('ngAfterViewInit');
    // this.slides.lockSwipes(true);
  }

  async requestSave() {
    console.log('this.serviceCheck', this.serviceCheck);
    if (this.serviceCheck) {
      if (!this.form.valid) {
        console.log('!this.form.valid');
        this.presentAlert('필수사항입력', '필수사항을 모두 입력해 주세요.');
      } else {
        console.log('this.form.valid', this.form.value);

        var data = {
          dateCreated: new Date().toString(),
          check: false,
          ...this.form.value,
        };
        this.db.updateAt('userRequest', data).then(() => {
          this.presentAlert('문의 완료', '문의가 완료되었습니다. 담당자가 확인후 연락드리겠습니다.');
        });
      }
    } else {
      this.presentAlert('개인정보처리방침', `개인정보처리방침에 동의하셔야 문의가 가능합니다.`);
    }
  }

  async presentAlert(headerText, subHeaderText) {
    const alert = await this.alertCtrl.create({
      header: headerText,
      // subHeader: 'Subtitle',
      subHeader: subHeaderText,
      buttons: ['확인'],
    });

    await alert.present();
  }

  scroll(el: HTMLElement) {
    // el.scrollIntoView({ behavior: 'smooth' });
    const id = document.getElementById(`${el}`);
    const yOffset = id.offsetTop - 90;
    const content = document.querySelector('ion-content');
    content.scrollToPoint(0, yOffset, 1000);
  }

  getBackgroundImageUrl(url) {
    console.log('url', url);

    return `url(${url})`;
  }

  // sendEmail(data){
  //   // Email.send({
  //   //   Host : 'smtp.elasticemail.com',
  //   //   Username : 'udith.indrakantha@gmail.com',
  //   //   Password : '**************************',
  //   //   To : 'kohyun@kncuration.com',
  //   //   From : 'kohyun@kncuration.com',
  //   //   Subject : '[홈페이지 문의]',
  //   //   Body : this.form.value
  //   //   }).then( message => {console.log("message",message);
  //   //   } );

  // }
}
